import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, mergeProps as _mergeProps, renderList as _renderList } from "vue"

const _hoisted_1 = ["data-qa"]
const _hoisted_2 = { class: "gfu-product__row" }
const _hoisted_3 = {
  key: 1,
  class: "gfu-product-details-gallery"
}
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "gfu-product-info" }
const _hoisted_6 = {
  key: 0,
  class: "gfu-product-info__badge"
}
const _hoisted_7 = { class: "_flex" }
const _hoisted_8 = {
  class: "gfu-product-info__name gfu-hd gfu-hd--d1 gfu-hd--decorative",
  "data-qa": "productinfo:ProductName"
}
const _hoisted_9 = {
  class: "gfu-price gfu-price--big _as-b",
  "data-qa": "price-type:Effective"
}
const _hoisted_10 = {
  class: "gfu-price gfu-price--old _fw-n _as-b _ml-1",
  "data-qa": "price-type:Old"
}
const _hoisted_11 = {
  class: "_mx-1",
  "data-qa": "price-type:ThirtyDaysLowest"
}
const _hoisted_12 = {
  key: 2,
  class: "_flex _my-3"
}
const _hoisted_13 = { class: "_mx-1" }
const _hoisted_14 = ["innerHTML"]
const _hoisted_15 = {
  key: 3,
  class: "_flex _mt-3"
}
const _hoisted_16 = { "data-qa": "productinfo:NonBuyable" }
const _hoisted_17 = {
  key: 0,
  class: "gfu-product-content _mt-3"
}
const _hoisted_18 = { class: "gfu-hd gfu-hd--h2 _tc--base _mb-3" }
const _hoisted_19 = { class: "gfu-hd gfu-hd--h2 _tc--base _mb-2" }
const _hoisted_20 = { ref: "footer-section-trigger" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_product_details_gallery = _resolveComponent("product-details-gallery")
  const _component_base_badge = _resolveComponent("base-badge")
  const _component_display_currency_price = _resolveComponent("display-currency-price")
  const _component_localize = _resolveComponent("localize")
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_optional_text = _resolveComponent("optional-text")
  const _component_add_product_to_cart = _resolveComponent("add-product-to-cart")
  const _component_product_details_set_items = _resolveComponent("product-details-set-items")

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['gfu-product', { 'gfu-product--modal': $options.isModal }]),
    "data-qa": `product-details-modal:${$props.productID}`
  }, [
    _createElementVNode("div", {
      class: _normalizeClass({ 'gfu-product__layout _pt-6': !$options.isModal })
    }, [
      _renderSlot(_ctx.$slots, "top"),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", {
          class: _normalizeClass(['gfu-product__gallery',
                              {'_mt_0': !$props.productCanBePurchased},
                              'gfu-1of1 gfu-1of2--m'])
        }, [
          ($props.imageList.length)
            ? (_openBlock(), _createBlock(_component_product_details_gallery, {
                key: 0,
                images: $props.imageList,
                onZoom: $options.onZoom
              }, null, 8 /* PROPS */, ["images", "onZoom"]))
            : (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createElementVNode("img", {
                  src: $props.mainImageUrl,
                  alt: $props.productName
                }, null, 8 /* PROPS */, _hoisted_4)
              ]))
        ], 2 /* CLASS */),
        _createElementVNode("div", {
          class: _normalizeClass(['gfu-product__info',
                              {'_mt_0' : !$props.productCanBePurchased},
                              'gfu-1of1 gfu-1of2--m']),
          "data-qa": "productinfo:TopRightBox"
        }, [
          _createElementVNode("div", _hoisted_5, [
            ($options.isDigital)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createVNode(_component_base_badge, { "data-qa": "product-details:DigitalBadge" }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.Resources.ProjectHome.DigitalProductBadge), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]))
              : _createCommentVNode("v-if", true),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("h1", _hoisted_8, _toDisplayString($props.productName), 1 /* TEXT */)
            ]),
            ($props.isBuyable)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_display_currency_price, {
                    price: $props.price,
                    "effective-price": $props.effectivePrice,
                    "is-discounted": $props.isDiscounted,
                    "data-qa": "product-modal:Price"
                  }, {
                    "effective-price": _withCtx(({ effectivePrice }) => [
                      _createElementVNode("span", _hoisted_9, _toDisplayString(effectivePrice), 1 /* TEXT */)
                    ]),
                    price: _withCtx(({ price }) => [
                      _createElementVNode("span", _hoisted_10, _toDisplayString(price), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  }, 8 /* PROPS */, ["price", "effective-price", "is-discounted"]),
                  ($props.isDiscounted)
                    ? (_openBlock(), _createBlock(_component_localize, {
                        key: 0,
                        resource: _ctx.Resources.Product.RewardCardLowestPriceInLast30Days,
                        tag: "div",
                        class: "_flex _ai-b gfu-bt gfu-bt--caption _tc--dark-gray"
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_display_currency_price, {
                            "format-key": "0",
                            "effective-price": $props.effectivePrice,
                            price: $props.price,
                            tag: "span"
                          }, {
                            "effective-price": _withCtx(({ effectivePrice }) => [
                              _createElementVNode("span", _hoisted_11, _toDisplayString(effectivePrice), 1 /* TEXT */)
                            ]),
                            _: 1 /* STABLE */
                          }, 8 /* PROPS */, ["effective-price", "price"])
                        ]),
                        _: 1 /* STABLE */
                      }, 8 /* PROPS */, ["resource"]))
                    : _createCommentVNode("v-if", true),
                  ($options.shouldShowStockLimit)
                    ? (_openBlock(), _createBlock(_component_base_badge, {
                        key: 1,
                        class: "gfu-product-info__badge",
                        "data-qa": "productinfo:StockLeft"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.Resources.format(_ctx.Resources.ProjectHome.ProductStockLeftLabel, _ctx.$format($options.remainingStockLimit, 'N0'))), 1 /* TEXT */)
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ], 64 /* STABLE_FRAGMENT */))
              : _createCommentVNode("v-if", true),
            ($props.estimatedDeliveryAt)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _createVNode(_component_base_icon, { name: "truck-fast" }),
                  _createElementVNode("span", _hoisted_13, _toDisplayString($options.estimatedDeliveryDateToLabel), 1 /* TEXT */),
                  ($props.deliveryDateRemarks)
                    ? (_openBlock(), _createBlock(_component_tooltip, { key: 0 }, {
                        content: _withCtx(() => [
                          _createElementVNode("span", { innerHTML: $props.deliveryDateRemarks }, null, 8 /* PROPS */, _hoisted_14)
                        ]),
                        default: _withCtx(() => [
                          _createVNode(_component_base_icon, { name: "circle-info" })
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]))
              : _createCommentVNode("v-if", true),
            _createVNode(_component_optional_text, {
              class: "gfu-product-info__abstract",
              content: $props.abstract,
              "data-qa": "productinfo:Abstract"
            }, null, 8 /* PROPS */, ["content"]),
            ($options.addProductToCartModel.readOnly)
              ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                  _createVNode(_component_base_icon, {
                    name: "circle-info",
                    class: "_mr-1"
                  }),
                  _createElementVNode("div", _hoisted_16, _toDisplayString($options.addProductToCartModel.tooltipText), 1 /* TEXT */)
                ]))
              : ($options.canAddToCart)
                ? (_openBlock(), _createBlock(_component_add_product_to_cart, _mergeProps({ key: 4 }, $options.addProductToCartModel, {
                    ref: "add-to-cart-button",
                    class: "gfu-product-info__add-to-cart _mt-3",
                    section: "reward-card-top",
                    onItemAdded: $options.onItemAdded,
                    onQuantityChanged: $options.onQuantityChange
                  }), null, 16 /* FULL_PROPS */, ["onItemAdded", "onQuantityChanged"]))
                : _createCommentVNode("v-if", true)
          ])
        ], 2 /* CLASS */)
      ]),
      ($props.productType === $data.productTypes.set && $props.setItems.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.Resources.ProjectHome.SetContentSectionHeader), 1 /* TEXT */),
            _createVNode(_component_product_details_set_items, {
              "set-items": $props.setItems,
              context: $props.context,
              "product-details-display-mode": $props.productDetailsDisplayMode
            }, null, 8 /* PROPS */, ["set-items", "context", "product-details-display-mode"])
          ]))
        : _createCommentVNode("v-if", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.productsDetailsData, ({ headerText, content, type }, index) => {
        return (_openBlock(), _createBlock(_component_optional_text, {
          key: `${index}-${headerText}`,
          class: "gfu-product-content _mt-3",
          content: content,
          "is-rich-text": true,
          "is-article": true,
          type: type
        }, {
          header: _withCtx(() => [
            _createElementVNode("h2", _hoisted_19, _toDisplayString(headerText), 1 /* TEXT */)
          ]),
          _: 2 /* DYNAMIC */
        }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["content", "type"]))
      }), 128 /* KEYED_FRAGMENT */))
    ], 2 /* CLASS */),
    ($options.canAddToCart)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          ref: "sticky-footer",
          class: _normalizeClass($options.stickyFooterClassList)
        }, [
          _createVNode(_component_add_product_to_cart, _mergeProps($options.addProductToCartModel, {
            class: "gfu-product-info__add-to-cart gfu-product-info__add-to-cart--sticky _mb-0",
            section: "reward-card-bottom",
            "wrapper-class-list": ['gfu-product__amount-wrapper--sticky'],
            onItemAdded: $options.onItemAdded,
            onQuantityChanged: $options.onQuantityChange
          }), null, 16 /* FULL_PROPS */, ["onItemAdded", "onQuantityChanged"])
        ], 2 /* CLASS */))
      : _createCommentVNode("v-if", true),
    _createElementVNode("div", _hoisted_20, null, 512 /* NEED_PATCH */)
  ], 10 /* CLASS, PROPS */, _hoisted_1))
}